(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('WarningMessageModalController', WarningMessageModalController);

    function WarningMessageModalController($uibModalInstance, modalTitle, modalMessage, smallText, warningText,
                                          buttonConfirmText, buttonCancelText, buttonConfirmAction, buttonCancelAction, cancelOnClose) {
        var vm = this;

        vm.modalTitle = modalTitle;
        vm.modalMessage = modalMessage;
        vm.smallText = smallText;
        vm.warningText = warningText;
        vm.buttonConfirmText = buttonConfirmText;
        vm.buttonCancelText = buttonCancelText;
        vm.buttonConfirmAction = action;

        var shouldCancelOnClose = cancelOnClose !== false;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.cancelModal = function() {
            if (buttonCancelAction) {
                buttonCancelAction();
            }
            $uibModalInstance.dismiss(true);
        }

        vm.closeModal = function() {
            if (shouldCancelOnClose && buttonCancelAction) {
                buttonCancelAction();
            }
            $uibModalInstance.dismiss(true);
        }

        function action(){
            buttonConfirmAction();
            vm.confirm();
        }
    }
})();
